// Stylesheets
import './assets/scss/site.scss';

import {fixSvgIntrinsicSizing} from './assets/modules/fixSvgIntrinsicSizing';
import {hover} from './assets/modules/hover';
import {lazyload} from './assets/modules/lazyload';
import {nav} from './assets/modules/nav';
import {archiveImage} from './assets/modules/archiveImage';
import {imageDraggable} from './assets/modules/imageDraggable';
import {initPhotoSwipeFromDOM} from './assets/modules/photoswipe-init';
import {Pjax} from 'pjax-api';

let removeCurrentParentOffsetTop = '';

const getOffset = (el) => {
  const box = el.getBoundingClientRect();
  return {
    top: box.top + window.pageYOffset - document.documentElement.clientTop,
    left: box.left + window.pageXOffset - document.documentElement.clientLeft
  }
}

const closest = (el, targetClass) => {
  for (let item = el; item; item = item.parentElement) {
    if (item.classList.contains(targetClass)) {
      return item
    }
  }
}

const scrollPos = () => {
  const current = document.querySelector('.js-post-trigger.is-current');
  const currentParent = closest(current, 'js-parent');
  if(currentParent) {
    const currentParentOffset = getOffset(currentParent);
    const currentParentOffsetTop = currentParentOffset.top;
    const ww = window.document.documentElement.clientWidth;
    if (ww >= 768) {
      window.scroll(0, currentParentOffsetTop);
    } else {
      window.scroll(0, currentParentOffsetTop);
      const header = document.getElementById('identity');
      const headerHeight = header.clientHeight;
      window.scroll(0, currentParentOffsetTop);
    }
  } else if(removeCurrentParentOffsetTop) {
    const ww = window.document.documentElement.clientWidth;
    if (ww >= 768) {
      window.scroll(0, removeCurrentParentOffsetTop);
    } else {
      window.scroll(0, removeCurrentParentOffsetTop);
      const header = document.getElementById('identity');
      const headerHeight = header.clientHeight;
      window.scroll(0, removeCurrentParentOffsetTop);
    }
    removeCurrentParentOffsetTop = '';
  }
}

const postTrigger = () => {
  const click = function(e) {
    const el = this;
    if(el.classList.contains('is-current')) {
      el.classList.add('setHref');
      const removeCurrentOffset = getOffset(el);
      removeCurrentParentOffsetTop = removeCurrentOffset.top;
    }
  }
  const trigger = document.getElementsByClassName('js-post-trigger');
  [].forEach.call(trigger, function(el) {
    el.removeEventListener('click', click, false);
    el.addEventListener('click', click, false);
  });
}

const init = () => {
  fixSvgIntrinsicSizing();
  hover();
  lazyload();
  postTrigger();
  scrollPos();
  initPhotoSwipeFromDOM('.js-pswp-container');
}

nav();
archiveImage();
imageDraggable();
init();

new Pjax({
  areas: [
    '.single-content, .js-post-trigger, #nav, #profile',
    '#main, #nav, #profile',
    'body'
  ],
  update: {
    css: false,
    script: false
  }
});
 
let routerBefore = document.getElementById('nav').getAttribute('data-router');
document.addEventListener('pjax:content', function(e) {
  const router = document.getElementById('nav').getAttribute('data-router');

  if(router == 'index') {
    if(routerBefore !== 'index') {
      archiveImage();
      imageDraggable();
    }

    const category = document.getElementById('nav').getAttribute('data-category');
    const posts = document.querySelectorAll('.js-posts');
    const currentClass = `category-${category}`;

    if(category){
      for(let i = 0; i < posts.length; i++) {
        const el = posts[i];
        if(el.classList.contains(currentClass)) {
          el.classList.remove('is-hide');
          el.classList.add('is-current');
        } else {
          el.classList.remove('is-current');
          el.classList.add('is-hide');
        }
      }
    } else {
      for(let i = 0; i < posts.length; i++) {
        const el = posts[i];
        el.classList.remove('is-current', 'is-hide');
      }
    }

    const setHref = document.querySelector('.js-post-trigger.setHref');
    if(setHref) {
      setHref.setAttribute('href', setHref.dataset.href);
      setHref.classList.remove('setHref');
    }
    const removeHref = document.querySelector('.js-post-trigger.removeHref');
    if(removeHref) {
      removeHref.setAttribute('href', '/');
      removeHref.classList.remove('removeHref');
    }

    const singleContent = document.querySelectorAll('.js-single-content');
    if(singleContent) {
      for(let i = 0; i < singleContent.length; i++) {
        const el = singleContent[i];
        if(el.classList.contains('is-current')) {
          const parent = closest(el, 'js-parent');
          if(parent) {
            parent.classList.add('current-parent');
          }
        } else {
          const parent = closest(el, 'js-parent');
          if(parent) {
            parent.classList.remove('current-parent');
          }
        }
      }
    }
  } else if(router == 'page') {

  }
  routerBefore = router;
});
 
document.addEventListener('pjax:ready', function(e) {
  document.body.classList.remove('is-nav-active');
  init();
  gtag('config', ga_code, {'page_path' : location.pathname});
});